export function arrayBufferToHex(buffer: ArrayBuffer | Uint8Array): string {
    const byteArray = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    
    return Array.from(byteArray) 
        .map((byte: number) => byte.toString(16).padStart(2, "0"))
        .join("");
}

